export default __webpack_public_path__ + "static/media/avatar_merlion3.fb32838d.mp3";